import React from "react"

interface FieldErrorsProps {
  errors?: string[]
  className?: string
  id?: string
}

export default function FieldErrors({
  errors,
  className,
  id,
}: FieldErrorsProps) {
  if (!errors?.length) {
    return null
  }

  return (
    <span
      id={id}
      className={className ? `help-block ${className}` : "help-block"}
    >
      {errors.join(". ")}
    </span>
  )
}
